export default "__VITE_ASSET__38814080__"